var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00391 9.61328H0V10.9375H8.00391V9.61328ZM6 5.60547H0V6.94141H6V5.60547ZM3.99609 1.60938H0V2.94531H3.99609V1.60938ZM9.99609 3.21484L11.0625 4.28125L12 3.33203L9.32812 0.671875L6.66797 3.33203L7.60547 4.28125L8.67188 3.21484V8.27734H9.99609V3.21484Z",
    fill: "#686E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.6f552362114a6bf4c5bec3bbf6f20313.svg";
export { ForwardRef as ReactComponent };